module.exports = __webpack_public_path__ + "static/4worldDesignGroup-9cf5ac1f69ef7f7d7a47e2f7fdfba00e.png";